var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingCameraButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15451",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15451",
    transform: "translate(-500 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9436",
    "data-name": "\\u9577\\u65B9\\u5F62 9436",
    width: 40,
    height: 40,
    transform: "translate(500 361)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "webcam",
    transform: "translate(505 363)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_4593",
    "data-name": "\\u6955\\u5186\\u5F62 4593",
    cx: 4.88,
    cy: 4.88,
    rx: 4.88,
    ry: 4.88,
    transform: "translate(10.513 10.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20952",
    "data-name": "\\u30D1\\u30B9 20952",
    d: "M24.194,31.76A15.38,15.38,0,1,0,8.8,16.394,15.389,15.389,0,0,0,24.194,31.76ZM23.469,3.147a.725.725,0,1,1,1.45,0V4.765a.725.725,0,0,1-1.45,0Zm.725,4.88a8.366,8.366,0,1,1-8.366,8.366A8.355,8.355,0,0,1,24.194,8.028Z",
    transform: "translate(-8.8 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20953",
    "data-name": "\\u30D1\\u30B9 20953",
    d: "M34,109.477A16.641,16.641,0,0,1,24.91,106.8l-2.51,5.633H45.6l-2.51-5.633A16.641,16.641,0,0,1,34,109.477Z",
    transform: "translate(-18.608 -77.295)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingCameraButton);
export default __webpack_public_path__ + "static/media/settingCameraButton.88b724c9f8721af094bcbf362b308a44.svg";
export { ForwardRef as ReactComponent };